/*
window.onloadGCallback = function() {
  grecaptcha.render('btn-subscribe-news', {
    'sitekey' : '6LfVzbMUAAAAAAieUYrr_ZvpuxV_zXhWXd-7zRKD',
    'size': 'invisible',
    'callback' : function(token) {
      console.log('token: ' + token);

      $('#newsletter_form').submit();

      return true;
    }
  });
};
*/

window.onloadGCallback = function (){
};

jQuery(document).ready(function() {
  if ($('.section_instagram').length > 0) {
    var feedWrap = $('.instafeed_wrap');
    var feedID = feedWrap.attr('id');
    var feedUser = feedWrap.data('user');
    var feedToken = feedWrap.data('token');
    var feedLimit = feedWrap.data('limit');

    var feed = new Instafeed({
      target: feedID,
      get: 'user',
      userId: feedUser,
      accessToken: feedToken,
      limit: feedLimit,
      template: '<div class="col-xs-4 instagram_item"><a href="{{link}}" style="background-image: url( {{image}} );"></a></div>',
      resolution: 'low_resolution',
      error: function( data ) {
          document.getElementById(feedID).innerHTML = '<p class="alert alert-danger"><b>Instagram error</b><br>' + data + '</p>';
      }
    });

    feed.run();
  }

  /*
  $(window).on('load',function() {
    grecaptcha.render('btn-subscribe-news', {
      'sitekey' : '6LfVzbMUAAAAAAieUYrr_ZvpuxV_zXhWXd-7zRKD',
      'size': 'invisible',
      'callback' : function(token) {
        console.log('token: ' + token);

		$('#btn-subscribe-submit').click();
        return true;
      }
    });
  });
  */
 
});